<template>
  <div class="home-content">
    <div class="home-head">
      <form action=".">
        <el-input v-model="searchText" type="search" class="home-head-seach" placeholder="搜索内容"
          prefix-icon="el-icon-search" autocomplete="off" @keyup.enter="searchTextSubmit" clearable></el-input>
        <input type="text" style="display: none;" />
      </form>
    </div>
    <div class="home-banner">
      <van-swipe class="my-swipe" :autoplay="3000" indicator-color="#0065E3" height="128" lazy-render>
        <van-swipe-item v-for="(k, item) in bannerVos" :key="item">
          <template v-if="k.url === null || k.ur === ''">
            <img :src=k.imageId />
          </template>
          <template v-else>
            <a :href="k.url" target="_blank">
              <img :src=k.imageId />
            </a>
          </template>
        </van-swipe-item>
      </van-swipe>
    </div>
    <div class="home-type" v-if="categoryVos.length > 1">
      <van-grid :gutter="15" :border=false class="home-type-grid">
        <van-grid-item v-for="(item, value) in categoryVos" :key="value" class="grid-item" @click="getMoreType(item)">
          <template v-if="item.more === true">
            <img src="../assets/image/home-type-more-icon.png" class="home-type-img" />
          </template>
          <template v-else-if="item.image != null && item.image != ''">
            <img :src="item.image" class="home-type-img" />
          </template>
          <template v-else>
            <img src="../assets/image/home-type-icon.png" class="home-type-img" />
          </template>
          <div class="home-type-text">{{ item.name }}</div>
        </van-grid-item>
      </van-grid>
    </div>
    <div class="home-teachingGather">
      <div class="home-teachingGather-top">
        <div class="home-teachingGather-title">{{ indexLabel }}</div>
        <div class="home-teachingGather-more" @click="toSearchPage()">查看更多<i class="el-icon-arrow-right"></i></div>
      </div>
      <div class="home-teachingGather-list">
        <el-row :gutter="10">
          <el-col :span="12" v-for="(item, value) in teachingGatherVos" :key="value" @click="toTeachDetail(item)">
            <div class="grid-content bg-purple">
              <template v-if="item.image != null && item.image != ''">
                <img :src="item.image" class="grid-content-img" />
              </template>
              <template v-else>
                <img src="../assets/image/teaching-img.png" class="grid-content-img" />
              </template>
              <div class="grid-content-text">
                <div class="grid-content-name"> {{ item.name }}</div>
                <template v-if="item.isOpen === '0'">
                  <div class="grid-content-price green">免费</div>
                </template>
                <template v-else>
                  <div class="grid-content-price red">¥ {{ item.price }}</div>
                </template>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import { getHomePageInfo } from '@/api/common'   //路径
import { wexinShare } from '../utils/wexinShare.js'
import { getWeChatAutograph } from '@/api/common'
export default {
  name: 'HomeDetailPage',
  props: {
    data: {
      type: Object
    },
  },
  data() {
    return {
      searchText: '',
      bannerVos: [],
      categoryVos: [{
        id: -1,
        image: '',
        name: '更多分类',
        more: true
      }],
      indexLabel: '',
      teachingGatherVos: [],
      name: '',
      merchantId: ''
    }
  },
  mounted() {
    let path = window.location.href;
    sessionStorage.setItem("iOS-URL", path);
    this.merchantId = this.data.merchantId;
    this.checkWeChatShare(this.merchantId);
    this.getHomeInfo(this.merchantId);
  },

  methods: {
    getHomeInfo(id) {
      let params = {
        'merchantId': id,
        'countCategory': 7,
        'countTeachingGather': 6
      };
      getHomePageInfo(params).then((res) => {
        if (res.code === 200) {
          this.bannerVos = res.bannerVos;
          if (res.categoryVos && res.categoryVos.length > 0) {
            this.categoryVos = res.categoryVos.concat(this.categoryVos);
          }
          this.teachingGatherVos = res.teachingGatherVos;
          this.indexLabel = res.indexLabel;
          document.title = res.name;
        }
      })
    },
    getMoreType(item) {
      if (item.more && item.more != null) {
        this.$router.push({ path: '/home/' + this.merchantId, query: { value: 'allTeachTypePage' } });
      } else {
        this.$router.push({
          path: '/home/' + this.merchantId, query: {
            value: 'searchPage',
            type: '1',  // 0：首页搜索 1：分类搜索
            searchText: '',
            categoryId: item.id,
            title: item.name
          }
        });
      }
    },
    searchTextSubmit() {
      this.$router.push({
        path: '/home/' + this.merchantId, query: {
          value: 'searchPage',
          type: '0',  // 0：首页搜索 1：分类搜索
          searchText: this.searchText
        }
      });
    },
    toSearchPage() {
      this.$router.push({
        path: '/home/' + this.merchantId, query: {
          value: 'searchPage',
          type: '0',  // 0：首页搜索 1：分类搜索
          searchText: ''
        }
      });
    },
    toTeachDetail(item) {
      this.$router.push({
        path: '/teaching/' + this.merchantId, query: {
          teachingId: item.id,
        }
      });
    },
    checkWeChatShare(merchantId) {
      //通过正则表达式匹配broser 中是否含有MicroMessenger字符串
      var broser = window.navigator.userAgent.toLowerCase();
      if (broser.match(/MicroMessenger/i) == 'micromessenger') {
          let authUrl = sessionStorage.getItem("iOS-URL") || null;
          if(authUrl == null) {
            return;
          } else {
            this.share(merchantId, authUrl);
          }
        // // 设备判断
        // let ua = navigator.userAgent;
        // // Android
        // let isAndroid = ua.indexOf("Android") > -1 || ua.indexOf("Linux") > -1;
        // // iOS
        // let isIos = !!window.__wxjs_is_wkwebview;
        // // IOS
        // if (isIos) {
        //   let authUrl = sessionStorage.getItem("iOS-URL") || null;
        //   if(authUrl == null) {
        //     let path = window.location.href;
        //     sessionStorage.setItem("iOS-URL", path);
        //     this.share(merchantId, path);
        //   } else {
        //     this.share(merchantId, authUrl);
        //   }
        // }
        // // Android
        // if (isAndroid) {
        //   let path = window.location.href;
        //    this.share(merchantId, path);
        // }
      }
    },
    share(merchantId, path) {
      if (merchantId != null && merchantId != '') {
          let params = {
            merchantId: merchantId,
            shareUrl: path
          };
          getWeChatAutograph(params).then((res) => {
            if (res.code === 200) {
              let newPath = window.location.href;
              let active = localStorage.getItem('loginInfo') || null;
              if (active != null) {
                if (newPath.includes('?')) {
                  newPath = newPath + '&memberId=' + JSON.parse(active).id;
                } else {
                  newPath = newPath + '?memberId=' + JSON.parse(active).id
                }
              } 
              res.link = newPath;
              wexinShare(res)
            }
          })
        }
    }
  }

}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.home-content {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 50px);
  overflow: hidden;
}

.home-head {
  padding: 10px 15px;
}

.home-head-seach {
  margin: 0;
  height: 40px !important;
  line-height: 40px;
  border-radius: 18px;
  overflow: hidden;
}

.home-head-seach :deep(.el-input__inner) {
  font-size: 14px;
  color: #333333;
  border: 0;
  border-radius: 18px;
  background: #F2F2F2;
  outline: none;
}

::v-deep input[type="search"]::-webkit-search-decoration,
::v-deep input[type="search"]::-webkit-search-cancel-button {
  -webkit-appearance: none;
  appearance: none;
  display: none;
}

.home-banner {
  padding: 0 15px;
}

.my-swipe .van-swipe-item {
  color: #fff;
  font-size: 20px;
  text-align: center;
}

.my-swipe .van-swipe-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 16px;
}

.home-type {
  margin-top: 20px;
  padding: 0 15px;
}

.home-type-img {
  margin-bottom: 10px;
  width: 44px;
  height: 44px;
  object-fit: cover;
  border-radius: 10px;
}

.home-type-text {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333333;
  text-align: center;
  font-weight: 400;
}

.grid-item {
  padding: 0 !important;
  height: 71px;
}

.home-type-grid {
  padding: 0 !important;
}

::v-deep .van-grid-item__content {
  padding: 0 !important;
}

.home-teachingGather {
  flex: 1;
  background-color: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.home-teachingGather-top {
  padding: 20px 15px 7px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #fff;
}

.home-teachingGather-title {
  font-family: PingFangSC-Medium;
  font-size: 16px;
  color: #333333;
  font-weight: 500;
}

.home-teachingGather-more {
  font-family: PingFangSC-Regular;
  font-size: 12px;
  color: #333333;
  font-weight: 400
}

.home-teachingGather-list {
  flex: 1;
  padding: 10px;
  overflow-y: auto;
}

.el-col {
  margin-bottom: 10px;

  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  border-radius: 5px;
  overflow: hidden;
}

.bg-purple-dark {
  background: #fff;
}

.bg-purple {
  background: #fff;
}

.bg-purple-light {
  background: #fff;
}

.grid-content {
  display: flex;
  flex-direction: column;
  border-radius: 5px;
  height: 184px;
  overflow: hidden;
  background-color: #fff;
}

.row-bg {
  padding: 10px 0;
  background-color: #fff;
}

.grid-content-img {
  width: 100%;
  height: 110px;
  object-fit: cover;
}

.grid-content-text {
  flex: 1;
  padding: 10px;
}

.grid-content-name {
  height: 34px;
  font-family: PingFangHK-Medium;
  font-size: 12px;
  color: #333333;
  text-align: justify;
  font-weight: 500;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}

.grid-content-price {
  margin-top: 8px;
  font-family: PingFangHK-Regular;
  font-size: 10px;
  text-align: left;
  font-weight: 400;
}

.grid-content-price.green {
  color: #13D275;
}

.grid-content-price.red {
  color: #F11515;
}
</style>